import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from '@components/common'
import './AccessDenied.scss'

/**
 * AccessDenied Page
 *
 * Displayed when a user attempts to access a route they don't have permission for.
 * Provides options to go back or return to dashboard.
 */
const AccessDenied = () => {
	const navigate = useNavigate()

	const handleGoBack = () => {
		navigate(-1)
	}

	const handleGoToDashboard = () => {
		navigate('/dashboard')
	}

	return (
		<div className="access-denied-page">
			<div className="access-denied-container">
				<div className="access-denied-icon">
					<i className="icon-lock"></i>
				</div>

				<h1 className="access-denied-title">Access Denied</h1>

				<p className="access-denied-message">
					You don't have permission to access this page.
					Please contact your administrator if you believe this is an error.
				</p>

				<div className="access-denied-code">
					<span>Error 403</span>
				</div>

				<div className="access-denied-actions">
					<Button
						variant="outline"
						onClick={handleGoBack}
					>
						<i className="icon-arrow-left"></i>
						Go Back
					</Button>

					<Button
						variant="primary"
						onClick={handleGoToDashboard}
					>
						<i className="icon-grid"></i>
						Go to Dashboard
					</Button>
				</div>

				<div className="access-denied-help">
					<p>
						Need help? Contact your system administrator or
						<a href="mailto:support@example.com"> support team</a>.
					</p>
				</div>
			</div>
		</div>
	)
}

export default AccessDenied
